<template>
  <div class="theme3">
    <header-page ref="headerPage"></header-page>
    <div class="content-box">
      <div class="layout-main" v-if="routers && routers.length > 0" >
        <div class="layout-left" :style="defaultHeight">
          <div class="leftSidebar-main">
            <div class="nav-menu-body" id="headerMenu">
              <el-menu
                class="sidebar-el-menu"
                background-color="#FFF"
                text-color="#000000"
                active-text-color="#1890FF"
                :default-active="activeMenu"
                @select="handleSelect"
                :default-openeds="defaultOpenArr"
                router
              >
                <template v-for="item in routers">
                  <template v-if="item.children">
                    <el-submenu :index="item.index" :key="item.index">
                      <template slot="title">
                        <i :class="item.meta.icon"></i>
                        <span>{{ item.meta != null ? item.meta.title : ''}}</span>
                      </template>
                      <template v-for="subItem in item.children">
                        <el-submenu v-if="subItem.children" :index="subItem.name" :key="subItem.name">
                          <i :class="subItem.meta.icon"></i>
                          <template slot="title"><i :class="subItem.meta.icon"></i>{{ subItem.meta != null ? subItem.meta.title : '' }}</template>
                          <el-menu-item
                            v-for="(threeItem, i) in subItem.children"
                            :key="i"
                            :index="threeItem.name"
                            :class="$route.name === threeItem.name ? 'is-select-menu' : ''"
                          >{{ threeItem.meta != null ? threeItem.meta.title : '' }}</el-menu-item>
                        </el-submenu>
                        <el-menu-item
                          v-else
                          :index="subItem.name"
                          :key="subItem.name"
                          :class="$route.name === subItem.name ? 'is-select-menu' : ''"
                        ><i :class="subItem.meta.icon"></i>{{ subItem.meta != null ? subItem.meta.title : '' }}</el-menu-item>
                      </template>
                    </el-submenu>
                  </template>
                  <template v-else>
                    <el-menu-item :index="item.name" :key="item.name" :class="$route.name === item.name ? 'is-select-menu' : ''">
                      <i :class="item.meta.icon"></i>
                      <template #title>{{ item.meta.title }}</template>
                    </el-menu-item>
                  </template>
                </template>
              </el-menu>
            </div>
          </div>
        </div>
        <div class="layout-right" :style="defaultHeight">
          <router-view v-slot="{ Component }" :key="$route.name">
            <transition name="move" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
      </div>
      <div class="content" v-else>
        <router-view v-slot="{ Component }" :key="$route.name">
          <transition name="move" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </div>
  </div>
</template>

<script>
import headerPage from './HeaderPage'
import vTags from "../../Tags.vue";
import {mapGetters} from "vuex";
export default {
  name: "index",
  data() {
    return {
      routers: [],
      defaultOpenArr: [],
      activeMenu: '',
      defaultHeight: {
        height: ""
      },
    };
  },
  components: {
    headerPage,
    vTags
  },
  watch: {
    '$route': 'defaultLeftNavOpened'  //监听router值改变时，改变导航菜单激活项
  },
  computed: {
    tagsList() {
      return this.$store.state.tagsList.map(item => item.name);
    },
    ...mapGetters([
      'routesLists'
    ]),
  },
  methods: {
    //定义方法，获取高度减去头尾
    getHeight() {
      this.defaultHeight.height = window.innerHeight - 80 + "px";
    },
    //选择菜单
    handleSelect(key, keyPath) {
      this.activeMenu = key;
    },
    // 左侧导航栏根据当前路径默认打开子菜单（如果当前路由是三级，则父级子菜单默认打开）
    defaultLeftNavOpened () {
      let defaultOpenArr = [];
      let cur_path = this.$route.path; //获取当前路由
      let routers = []; // 获取路由对象
      let routesLists = this.routesLists;
      let topName = "";
      if(this.$route && this.$route.meta && this.$route.meta.topName){
          topName = this.$route.meta.topName;
      }
      for(let i = 0; i < routesLists.length; i++){
        if(routesLists[i].name == topName && routesLists[i].children && routesLists[i].children.length > 0){
          routers = routesLists[i].children
        }
      }

      let subMenuIndex = 0, needOpenSubmenu = false;
      for (let i = 0; i < routers.length; i++) {
        let children = routers[i].children;
        if(children){
          let isNowChild = false;
          for(let j = 0; j < routers.length; j++){
            if(children[j] && children[j].name == this.$route.name){
              isNowChild = true;
            }
          }
          //如果这个菜单是当前路由的地址
          if(!!routers[i].index && isNowChild){
            defaultOpenArr.push(routers[i].index)
          }

          for (let j = 0; j < children.length; j++) {
            if (children[j].path === cur_path) {
              break;
            }
            // 如果该菜单下有子菜单(个数>1且设置的leaf为false才有下拉子菜单)
            if(children[j].children && !children[j].leaf) {
              let grandChildren = children[j].children;
              for(let z=0; z<grandChildren.length; z++) {
                if(grandChildren[z].path === cur_path) {
                  subMenuIndex = j;
                  needOpenSubmenu = true;
                  break;
                }
              }
            }
          }
        }
      }
      if(this.$refs['leftNavigation'] && needOpenSubmenu) {
        this.$refs['leftNavigation'].open(subMenuIndex); // 打开子菜单
      }

      this.routers = routers;
      this.defaultOpenArr = defaultOpenArr;

    },
  },
  created() {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    // window.addEventListener("resize", this.getHeight);
    this.getHeight();
  },
  mounted() {
    this.defaultLeftNavOpened();
  }
}
</script>

<style scoped>
  .content{background: #efefef;}
  .el-menu-item.is-select-menu{background: #e6f7ff !important; color: #1890FF !important;}
  /deep/.leftSidebar-main .el-submenu__title:hover{background: #FFF !important; color: #1890FF !important;}
  .el-menu-item:hover{background: #e6f7ff !important; color: #1890FF !important;}
  .el-menu-item.is-select-menu:after{position: absolute; top: 0; right: 0; bottom: 0; border-right: 3px solid #1890FF;content: ''}
  .el-menu-item{height: 50px !important;line-height: 50px !important; font-size: 16px;}
  /deep/.leftSidebar-main .el-menu-item{height: 50px !important; line-height: 50px !important;}
  /deep/.leftSidebar-main .el-submenu__title{height: 50px !important; line-height: 50px !important;}

  .layout-left{overflow-x: hidden; overflow-y: auto;}
  .el-submenu .wk{
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
    display: inline-block;
  }

  .el-menu-item .wk{
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/theme/theme3/index.vue